import axios from 'api/axios'

const baseCompras = (pk) => `/efactura/compras/${pk}/fichero/`
const baseVentas = (pk) => `/efactura/ventas/${pk}/fichero/`

/**
 * Descarga bajo demanda el fichero (base64) de una factura de compras.
 *
 * El listado (`cw_regfrapro`) ya no arrastra el `fichero`; se pide a este
 * endpoint por pk al pulsar descargar (expediente 1817225).
 *
 * @param {number|string} pk - Identificador de la factura de compras
 * @returns {Promise<{fichero: string, nombre_archivo: string}>}
 */
export const descargarFicheroCompra = (pk) => axios.get(baseCompras(pk)).then((r) => r.data)

/**
 * Descarga bajo demanda el fichero (base64) de una factura de ventas.
 *
 * @param {number|string} pk - Identificador de la factura de ventas
 * @returns {Promise<{fichero: string, nombre_archivo: string}>}
 */
export const descargarFicheroVenta = (pk) => axios.get(baseVentas(pk)).then((r) => r.data)
